import { isSameOrBefore } from "@oysterhr/common"
import { getMonthOptions } from "./getMonthOptions"

export const getEndingMonthOptions = (
  monthOptions: ReturnType<typeof getMonthOptions>,
  startingMonth?: string | null,
) => {
  if (!startingMonth) {
    return []
  }

  return monthOptions?.filter(({ value }) => !isSameOrBefore(value, startingMonth))
}
